var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjRouteTabs", {
        attrs: {
          "route-list": _vm.isVerify ? _vm.STOCK_VERIFY_ROUTE_LIST : [],
        },
      }),
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          selection: _vm.selection,
          "before-reset-search": _vm.beforeResetSearch,
          "before-query-search": _vm.beforeQuerySearch,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "预留锁定单号 ", prop: "code" } },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t("inputText"),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.code,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "code", $$v)
                            },
                            expression: "queryParams.code",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "仓库编码", prop: "warehouseCode" } },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t("inputText"),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.warehouseCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "warehouseCode", $$v)
                            },
                            expression: "queryParams.warehouseCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "仓库名称", prop: "warehouseIdList" } },
                      [
                        _c("BjSelectWarehouse", {
                          attrs: {
                            multiple: "",
                            "type-code": ["logic"],
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.warehouseIdList,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "warehouseIdList", $$v)
                            },
                            expression: "queryParams.warehouseIdList",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("table.statusText"),
                          prop: "statusList",
                        },
                      },
                      [
                        !_vm.isVerify
                          ? _c("BjSelectLov", {
                              attrs: {
                                multiple: "",
                                "option-list": _vm.isVerify
                                  ? _vm.STOCK_TRANSFER_VERIFY_TYPE_LIST
                                  : _vm.STOCK_LOCK_STATUS_LIST,
                              },
                              model: {
                                value: _vm.queryParams.statusList,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "statusList", $$v)
                                },
                                expression: "queryParams.statusList",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "生效时间" } },
                      [
                        _c("el-date-picker", {
                          staticClass: "full-width",
                          attrs: {
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            type: "datetimerange",
                            "picker-options": _vm.$pickerOptions(),
                            align: "right",
                            "start-placeholder": _vm.$t("form.startDateText"),
                            "end-placeholder": _vm.$t("form.endDateText"),
                            "default-time": ["00:00:00", "23:59:59"],
                          },
                          model: {
                            value: _vm.queryParamsEffectiveTime,
                            callback: function ($$v) {
                              _vm.queryParamsEffectiveTime = $$v
                            },
                            expression: "queryParamsEffectiveTime",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("table.createTimeText") } },
                      [
                        _c("el-date-picker", {
                          staticClass: "full-width",
                          attrs: {
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            type: "datetimerange",
                            "picker-options": _vm.$pickerOptions(),
                            align: "right",
                            "start-placeholder": _vm.$t("form.startDateText"),
                            "end-placeholder": _vm.$t("form.endDateText"),
                            "default-time": ["00:00:00", "23:59:59"],
                          },
                          model: {
                            value: _vm.queryParamsTime,
                            callback: function ($$v) {
                              _vm.queryParamsTime = $$v
                            },
                            expression: "queryParamsTime",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function () {
              return [
                _c(
                  "el-col",
                  [
                    !_vm.isVerify
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission:BusinessStockLockAdd",
                                arg: "BusinessStockLockAdd",
                              },
                            ],
                            staticClass: "main-btn",
                            attrs: { type: "primary" },
                            on: { click: _vm.onAdd },
                          },
                          [_vm._v(_vm._s(_vm.$t("addText")))]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    _vm.filterLabels.includes(col.prop) &&
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : !_vm.isVerify && col.prop === "code"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "link",
                                            on: {
                                              click: function ($event) {
                                                return _vm.onView(scope.row)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(scope.row[col.prop]) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : col.prop === "status"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.STOCK_LOCK_STATUS_LIST.bjGet(
                                                    scope.row[col.prop]
                                                  )
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    _vm.filterLabels.includes(col.prop) &&
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    !_vm.isVerify
                                      ? [
                                          _c(
                                            "el-button",
                                            {
                                              directives: [
                                                {
                                                  name: "permission",
                                                  rawName:
                                                    "v-permission:BusinessStockLockIndex_Status",
                                                  arg: "BusinessStockLockIndex_Status",
                                                },
                                              ],
                                              attrs: {
                                                disabled:
                                                  scope.row.status !==
                                                  "success",
                                                type: "text",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onStatus(
                                                    "close",
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("停用")]
                                          ),
                                          _c(
                                            "el-button",
                                            {
                                              directives: [
                                                {
                                                  name: "permission",
                                                  rawName:
                                                    "v-permission:BusinessStockLockIndex_Abandon",
                                                  arg: "BusinessStockLockIndex_Abandon",
                                                },
                                              ],
                                              attrs: {
                                                disabled:
                                                  scope.row.status !== "wait",
                                                type: "text",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onStatus(
                                                    "abandon",
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("作废")]
                                          ),
                                          _c(
                                            "el-button",
                                            {
                                              directives: [
                                                {
                                                  name: "permission",
                                                  rawName:
                                                    "v-permission:BusinessStockLockIndex_Status",
                                                  arg: "BusinessStockLockIndex_Status",
                                                },
                                              ],
                                              attrs: {
                                                disabled:
                                                  scope.row.status !== "close",
                                                type: "text",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onStatus(
                                                    "start",
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("enableText"))
                                              ),
                                            ]
                                          ),
                                        ]
                                      : [
                                          _c(
                                            "el-button",
                                            {
                                              directives: [
                                                {
                                                  name: "permission",
                                                  rawName: "v-permission",
                                                  value: _vm.isVerify
                                                    ? "BusinessStockVerifyLockView"
                                                    : "",
                                                  expression:
                                                    "isVerify ? 'BusinessStockVerifyLockView' : ''",
                                                },
                                              ],
                                              attrs: { type: "text" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onView(scope.row)
                                                },
                                              },
                                            },
                                            [_vm._v(_vm._s(_vm.$t("viewText")))]
                                          ),
                                          scope.row.status == "wait"
                                            ? _c(
                                                "el-button",
                                                {
                                                  directives: [
                                                    {
                                                      name: "permission",
                                                      rawName:
                                                        "v-permission:BusinessStockVerifyPlanIndex_Pass",
                                                      arg: "BusinessStockVerifyPlanIndex_Pass",
                                                    },
                                                  ],
                                                  staticClass: "main-btn",
                                                  attrs: { type: "text" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onAudit(
                                                        "success",
                                                        scope.row.id
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("审核通过")]
                                              )
                                            : _vm._e(),
                                          scope.row.status == "wait"
                                            ? _c(
                                                "el-button",
                                                {
                                                  directives: [
                                                    {
                                                      name: "permission",
                                                      rawName:
                                                        "v-permission:BusinessStockVerifyPlanIndex_Reject",
                                                      arg: "BusinessStockVerifyPlanIndex_Reject",
                                                    },
                                                  ],
                                                  attrs: { type: "text" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onAudit(
                                                        "fail",
                                                        scope.row.id
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("审核拒绝")]
                                              )
                                            : _vm._e(),
                                        ],
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }